/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Define routes
  Date: April 2020
**/

import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import BackIcon from '@material-ui/icons/ArrowBack';
import UserIcon from '@material-ui/icons/Person';
import ListIcon from '@material-ui/icons/List';
import BallotIcon from '@material-ui/icons/Ballot';
import ChangePasswordIcon from '@material-ui/icons/VpnKey';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import { MainLayout } from '../layout';
import {
  LoginPage,
  SsoCorporatePage,
  HomePage,
  ForgotPasswordPage,
  ChangePasswordPage,
  TermsOfUsePage,
  UsersPage,
  notFound,
  Branding,
  Domains,
  StandardReportPage,
  ReportPage,
  ReportAddage,
  ReportResultPage,
  standardReportFilter,
} from '../pages';
import OrganizationPage from '../pages/organization/organization';
import DiagnosisCodes from '../pages/diagnosisCodes/diagnosisCodes';
import { OrganizationDetailPage } from '../pages/organization/OrganizationDetailPage';
import ProceduresPage from '../pages/procedures/procedures';
import ImportPage from '../pages/import/import';
import EventLogs from '../pages/events/EventLogs';
import { ROLES } from '../submodule';

export const routes = [
  {
    label: 'Login',
    path: '/login',
    page: LoginPage,
    requireAuth: false,
    asMenu: false,
  },
  {
    label: 'SSO Login',
    path: '/ssologin',
    page: SsoCorporatePage,
    requireAuth: false,
    asMenu: false,
  },
  {
    label: 'Home',
    path: '/',
    page: HomePage,
    layoutType: MainLayout,
    requireAuth: true,
    icon: <HomeIcon />,
  },
  {
    label: 'Go Back',
    path: '/',
    page: HomePage,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: false,
    icon: <BackIcon />,
  },
  {
    label: 'ForgotPassword',
    path: '/forgotpassword',
    page: ForgotPasswordPage,
    requireAuth: false,
    asMenu: false,
  },
  {
    label: 'ChangePassword',
    path: '/changepassword',
    page: ChangePasswordPage,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: false,
    icon: <ChangePasswordIcon />,
  },
  {
    label: 'TermsofUse',
    path: '/termsofuse',
    page: TermsOfUsePage,
    requireAuth: false,
    asMenu: false,
  },
  {
    label: 'Users',
    path: '/users',
    page: UsersPage,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: false,
    icon: <UserIcon />,
  },
  {
    label: 'NotFound',
    path: '/not-found',
    page: notFound,
    layoutType: MainLayout,
    asMenu: false,
  },
  {
    label: 'Branding',
    path: '/branding',
    page: Branding,
    layoutType: MainLayout,
    requireAuth: true,
  },
  {
    label: 'DomainManagement',
    path: '/domains',
    page: Domains,
    layoutType: MainLayout,
    requireAuth: true,
    icon: <HomeIcon />,
  },
  {
    label: 'Tenants',
    path: '/organization',
    page: OrganizationPage,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: true,
    role:[ROLES.PLATFORM_ADMIN],
    isPlatformAdmin: true,
  },
  {
    label: 'Diagnosis Codes',
    path: '/diagnosis-codes',
    page: DiagnosisCodes,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: true,
    role:[ROLES.PLATFORM_ADMIN],
    icon: <ListIcon />,
  },
  {
    label: 'Tenant Details',
    path: '/organization/:id',
    page: OrganizationDetailPage,
    layoutType: MainLayout,
    requireAuth: true,
    isPlatformAdmin: true,
  },
  {
    label: 'Procedure Codes',
    path: '/procedures',
    page: ProceduresPage,
    layoutType: MainLayout,
    requireAuth: true,
    asMenu: true,
    role:[ROLES.PLATFORM_ADMIN],
    isPlatformAdmin: true,
    icon: <BallotIcon />,
  },
  {
    label: 'Standard Reports',
    path: '/reports/standard',
    page: StandardReportPage,
    layoutType: MainLayout,
    asMenu: true,
    role:[
      ROLES.PLATFORM_ADMIN, 
      ROLES.TENANT_ADMIN, 
      ROLES.PACHECK_ADMIN,
      ROLES.PACHECK_operator,
      ROLES.PACHECK_USER,
      ROLES.POLICY_ADMIN,
      ROLES.POLICY_OPERATOR,
      ROLES.POLICY_USER,
      // ROLES.AUTO_ADMIN,
      // ROLES.AUTO_OPERATOR,
      // ROLES.AUTO_USER,
    ],
    requireAuth: true,
  },
  {
    label: 'Report Builder',
    path: '/reports/custom',
    asMenu: true,
    page: ReportPage,
    layoutType: MainLayout,
    role:[
      ROLES.TENANT_ADMIN, 
      ROLES.PACHECK_ADMIN,
      ROLES.PACHECK_operator,
      ROLES.PACHECK_USER,
      ROLES.POLICY_ADMIN,
      ROLES.POLICY_OPERATOR,
      ROLES.POLICY_USER,
      // ROLES.AUTO_ADMIN,
      // ROLES.AUTO_OPERATOR,
      // ROLES.AUTO_USER,
    ],
    requireAuth: true,
  },
  // {
  //   label: 'New Report',
  //   path: '/reports/new',
  //   page: ReportAddage,
  //   layoutType: MainLayout,
  //   requireAuth: true,
  // },
  {
    label: 'Edit Report',
    path: '/reports/:id',
    page: ReportAddage,
    layoutType: MainLayout,
    requireAuth: true,
  },
  {
    label: 'Report Result',
    path: '/reportresult/:reporttype/:id',
    page: ReportResultPage,
    layoutType: MainLayout,
    requireAuth: true,
  },
  {
    label: 'Filter Standard Report',
    path: '/standardreport/:id',
    page: standardReportFilter,
    layoutType: MainLayout,
    requireAuth: true,
  },
  {
    label: 'Import',
    path: '/import',
    page: ImportPage,
    layoutType: MainLayout,
    requireAuth: true,
    icon: <ArrowUpward />,
  },
  {
    label: 'Events',
    path: '/events',
    page: EventLogs,
    layoutType: MainLayout,
    requireAuth: true,
    child: true,
  },
];
